module.exports = __webpack_public_path__ + "static/media/环境感应模块.e14f5a96.png";